"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionSheetItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var __1 = require("..");
var util_localization_1 = require("@sport-thieme/util-localization");
exports.ActionSheetItem = react_1.forwardRef(function WrappedMenuItem(_a, ref) {
    var confirm = _a.confirm, onClick = _a.onClick, label = _a.label, children = _a.children, close = _a.close, icon = _a.icon, rest = __rest(_a, ["confirm", "onClick", "label", "children", "close", "icon"]);
    var handleClick = function (event) {
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
        close === null || close === void 0 ? void 0 : close();
    };
    var menuItem = (jsx_runtime_1.jsx(MenuItem_1.default, __assign({ onClick: handleClick }, rest, { button: true, innerRef: ref }, { children: jsx_runtime_1.jsxs(__1.Grid, __assign({ container: true, spacing: 3 }, { children: [jsx_runtime_1.jsx(__1.Grid, __assign({ item: true, grow: true }, { children: jsx_runtime_1.jsx(Typography_1.default, __assign({ variant: "inherit", noWrap: true }, { children: label || children }), void 0) }), void 0),
                Boolean(icon) && jsx_runtime_1.jsx(__1.Grid, __assign({ item: true }, { children: icon }), void 0)] }), void 0) }), void 0));
    if (confirm) {
        var question = typeof confirm === 'string' ? confirm : util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["Are you sure?"], ["Are you sure?"])));
        return (jsx_runtime_1.jsx(__1.Confirmation, __assign({ question: question, onCancel: close }, { children: menuItem }), void 0));
    }
    return menuItem;
});
var templateObject_1;
//# sourceMappingURL=ActionSheetItem.js.map